<template>
	<sf-modal-layout size="l" :title="title" :show="show" :closeModal="close">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<mes-eqip-no-popup-search ref="MesEqipNoPopupSearch" :scrId="scrId"></mes-eqip-no-popup-search>
				</sf-card>
			</div>

			<div class="sf-col sf-col-20">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<mes-eqip-no-popup-table ref="MesEqipNoPopupTable" @SendData="sendData" :scrId="scrId"></mes-eqip-no-popup-table>
				</sf-card>
			</div>
		</div>
		<template v-slot:footer>
			<sf-button line :onClick="() => close()">
				{{ getMessage_('MWCC000343') }}
			</sf-button>
		</template>
	</sf-modal-layout>
</template>

<script>
import { serviceComputed, serviceMethods } from '@qms/comm/commpopup/MesEqipNoPopup/store/helpers';
import { rootComputed, rootMethods } from '@/store/common/helpers';

import MesEqipNoPopupSearch from './Content/Search/Search.vue';
import MesEqipNoPopupTable from './Content/Table/Table.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { MesEqipNoPopupSearch, MesEqipNoPopupTable },
	data() {
		return {
			show: false,
			title: '측정기관리번호'
		};
	},
	created() {
		this.setStateInit_();
		this.screen = this.screenArray.get(this.scrId);
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		open(param) {
			this.show = true;

			this.setSearchParam_({ key: 'eqipKndCd', value: param.eqipKndCd });
			this.setSearchParam_({ key: 'mesEqipNm', value: param.mesEqipNm });
			this.setSearchParam_({ key: 'usePlCd', value: param.usePlCd });
			if (this.$refs.MesEqipNoPopupSearch != undefined) {
				this.$refs.MesEqipNoPopupSearch.searchList();
			}
		},
		close() {
			// debugger;
			this.setSearchParam_({ key: 'eqipKndCd', value: null });
			this.setSearchParam_({ key: 'mesEqipNm', value: null });
			this.setSearchParam_({ key: 'usePlCd', value: null });

			this.$refs.MesEqipNoPopupSearch.reset();

			this.show = false;
		},
		reload(currentPage = 1, pageUnit = 10) {
			this.$refs.MesEqipNoPopupSearch.searchList(currentPage, pageUnit);
		},
		sendData(sendParam) {
			this.$emit('SendData', sendParam);
			this.close();
		}
	}
};
</script>

<style></style>
